import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import ChatbotWidget from '../components/chatbot/ChatbotWidget';
import AnnouncementBanner from '../components/announcements/AnnouncementBanner';

const DISMISSED_KEY  = 'cst_banner_dismissed_Ai0szL0TFYo';
const BANNER_HEIGHT  = 72; // must match height in AnnouncementBanner
const U = "'Urbanist', sans-serif";

function NonprofitStrip() {
  const orgs = [
    'Workforce Development Boards',
    'Veterans Service Organizations',
    'Re-Entry & Justice Programs',
    'Community Action Agencies',
    'Faith-Based Nonprofits',
    'Refugee Resettlement Programs',
  ];

  return (
    <div style={{
      background: '#EBF0F8',
      borderTop: '1px solid rgba(27,43,75,0.10)',
      borderBottom: '1px solid rgba(27,43,75,0.10)',
      padding: '28px 32px',
      fontFamily: U,
    }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@300;400;600;700;800&display=swap');`}</style>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '28px', height: '2px', background: '#A8B8C8' }} />
            <span style={{
              fontFamily: U, fontSize: '11px', fontWeight: 700,
              letterSpacing: '0.12em', textTransform: 'uppercase', color: '#A8B8C8',
            }}>
              Nonprofit Partnerships
            </span>
            <div style={{ width: '28px', height: '2px', background: '#A8B8C8' }} />
          </div>
          <span style={{
            fontFamily: U, fontSize: '13px', fontWeight: 400, color: '#5A6880',
          }}>
            California School of Trucking proudly works with{' '}
            <strong style={{ color: '#1B2B4B', fontWeight: 700 }}>501(c)(3) nonprofit organizations</strong>
            {' '}to fund CDL training for eligible candidates at reduced or no cost.
          </span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {orgs.map((org, i) => (
            <div key={i} style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              background: '#FFFFFF', border: '1px solid rgba(27,43,75,0.14)',
              borderRadius: '4px', padding: '6px 14px',
              fontFamily: U, fontSize: '12px', fontWeight: 600, color: '#1B2B4B',
            }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#A8B8C8', flexShrink: 0 }} />
              {org}
            </div>
          ))}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            background: '#1B2B4B', border: '1px solid #1B2B4B',
            borderRadius: '4px', padding: '6px 14px',
            fontFamily: U, fontSize: '12px', fontWeight: 700, color: '#FFFFFF',
          }}>
            & Many More
          </div>
        </div>

      </div>
    </div>
  );
}

export default function MainLayout({ children }) {
  const location = useLocation();
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(DISMISSED_KEY)) setBannerVisible(true);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setBannerVisible(false);
  };

  useEffect(() => {
    let observer;
    const timer = setTimeout(() => {
      const sections = document.querySelectorAll('section');
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.remove('sr-hidden');
              e.target.classList.add('sr-visible');
              observer.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -48px 0px' }
      );
      sections.forEach(el => {
        const rect = el.getBoundingClientRect();
        const belowFold = rect.top >= window.innerHeight;
        if (belowFold) el.classList.add('sr-hidden');
        observer.observe(el);
      });
    }, 60);

    return () => {
      clearTimeout(timer);
      if (observer) observer.disconnect();
      document.querySelectorAll('section.sr-hidden, section.sr-visible').forEach(el => {
        el.classList.remove('sr-hidden', 'sr-visible');
      });
    };
  }, [location.pathname]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {bannerVisible && <AnnouncementBanner onDismiss={handleDismiss} />}
      <Navbar topOffset={bannerVisible ? BANNER_HEIGHT : 0} />
      <main style={{
        flex: 1,
        paddingTop: bannerVisible ? `${BANNER_HEIGHT}px` : 0,
        transition: 'padding-top 0.25s ease',
      }}>
        {children}
      </main>
      <NonprofitStrip />
      <Footer />
      <ChatbotWidget />
    </div>
  );
}
